import "../css/MobileMenu.css";
import React from 'react';
import { Collapse } from "antd";
import ButtonComp from "./ButtonComp";
import HorizontalSpace from "./HorizontalSpace";
import { login } from "../langs/buttons";
import { marketsDir } from '../utils/routeUtils';

const { Panel } = Collapse;

const renderMenuItem = (item) => {  
  if ((!item.children || item.children.length === 0) && item.parentDatabaseId !== 0) {
    return (
      <a href={item.url} className="b4-body-500 mobile-menu-link">
        {item.label}
      </a>
    );
  }
  return item.children.map((child, idx) => (
    <div key={`submenu-${idx}`} className="b4-body-500 mobile-submenu-item">
      {renderMenuItem(child)}
    </div>
  ));
};

const MobileMenu = ({ menu, lang, GetLogo, LanguageBtn, toggleMenu, isMenuOpen }) => {
  
  const menuForLanguage = menu.find(item => item[lang]);
  const menuItems = menuForLanguage[lang];

  return (
    <nav className="mobile-menu">
      <div className="mobile-menu-icon" onClick={toggleMenu}>
        <div className={`bar ${isMenuOpen ? "open" : ""}`}></div>
        <div className={`bar ${isMenuOpen ? "open" : ""}`}></div>
        <div className={`bar ${isMenuOpen ? "open" : ""}`}></div>
      </div>
      <div className={`mobile-menu-list ${isMenuOpen ? "show" : ""}`}>
      <div className="mobile-menu-content">
          <Collapse ghost accordion expandIconPosition="end">
            {menuItems.map((item) => {
              const isMarkets = item.label.toLowerCase() === marketsDir(lang);
              return (
                <Panel
                  key={`panel-${item.label}`}
                  header={
                    <div className="menu-item-header">
                      <a
                        href={item.url || "#"}
                        onClick={(e) => !item.url && e.preventDefault()}
                        className={`b4-body-500 menu-title ${item.url ? "clickable" : ""}`}
                      >
                        {item.label}
                      </a>
                    </div>
                  }
                >
                  {item.children && (isMarkets
                    ? (
                      <div className="mobile-markets-scroll">
                        {item.children.map((region, idx) => (
                          <div key={`region-${idx}`} className="mobile-region-block">
                            <a className="b4-body-500 menu-title" href={region.url}>
                              {region.label}
                            </a>
                            <ul className="mobile-markets-list">
                              {region.children.map((market, mIdx) => (
                                <li key={`market-${mIdx}`} className="mobile-market-item">
                                  <a className="b4-body-400 mobile-market-link" href={market.url}>
                                    {market.label}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </div>
                        ))}
                      </div>
                    )
                    : renderMenuItem(item)
                  )}
                </Panel>
              )
            })}
          </Collapse>
        </div>
        <div className="mobile-menu-actions" gutter={[16, 16]}>
          <LanguageBtn/>
          <HorizontalSpace size={11} />
          <ButtonComp title={login[lang]} url={'https://shops.payretailers.com/login'} classStyle={'login-btn button-empty-sm-500'}/>
        </div>
      </div>
    </nav>
  );
};

export default MobileMenu;
